import React from "react";
import { useDarkMode } from "src/context/DarkModeContext";
import { CondicionalSimpleData } from "src/data/individual-topics/Conditional";
import ExplanationCard from "src/components/cards/ExplanationCard/ExplanationCard";
import ExampleCard from "src/components/cards/ExampleCard/ExampleCard";
import ConjugationTable from "src/components/tables/ConjugationTable";
import PageStructure from "src/components/wrappers/PageStructure";
import ExampleTitle from "src/components/ExampleTitle";


const CondicionalSimpleContent: React.FC = () => {
    const { isDarkMode } = useDarkMode();

    return (
        <div className={` ${isDarkMode ? "dark" : ""}`}>

            <div className="section">
                <ExplanationCard cardData={CondicionalSimpleData.explanation} />
            </div>

            <ExampleTitle />

            <div className="section" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                {CondicionalSimpleData.examples.map((example, index) => (
                    <ExampleCard key={index} example={example} />
                ))}
            </div>

            <div className="section">
                <ExplanationCard cardData={CondicionalSimpleData.timelineDescription} />
            </div>

            <div className="section">
                <ConjugationTable
                    tableData={{
                        title: "Regular Verbs",
                        verbs: CondicionalSimpleData.regularVerbs,
                    }}
                />
            </div>

            <div className="section">
                <ConjugationTable
                    tableData={{
                        title: "Irregular Verbs",
                        verbs: CondicionalSimpleData.irregularVerbs,
                    }}
                />
            </div>
        </div>
    );
};

const CondicionalSimpleScreen: React.FC = () => {
    return (
        <PageStructure
            TitleNode="Simple Conditional"
            Page={<CondicionalSimpleContent />}
        />
    );
};

export default CondicionalSimpleScreen;
